import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { NOTIFICATIONS_NS } from "@/components/notifications/i18n";
import { NotificationPrefs } from "@/components/notifications/notification-prefs";
import { NotificationsList } from "@/components/notifications/notifications-list";
import { PushToggle } from "@/components/notifications/push-toggle";

export const Route = createFileRoute("/notifications")({
	component: NotificationsPage,
});

/**
 * Раздел «Уведомления»: лента сверху, настройки доставки снизу.
 *
 * Отдельного макета у раздела нет — он собран в том же языке, что и Главная:
 * та же ширина колонки, тот же зазор 4px, те же карточки. Настройки стоят под
 * лентой, а не в отдельном разделе, потому что решение «слишком много писем»
 * человек принимает ровно в тот момент, когда смотрит на эти письма.
 */
function NotificationsPage() {
	const { t } = useTranslation(NOTIFICATIONS_NS);

	return (
		<div className="flex min-w-0 w-full flex-col gap-1">
			{/* Заголовок раздела скрыт визуально (карточки называют себя сами), но
			    он обязан быть `h1`: в остальных разделах он есть, и оглавление
			    страницы без него читается как «раздел без названия». */}
			<h1 className="sr-only">{t("title")}</h1>
			<span className="sr-only">{t("subtitle")}</span>
			<NotificationsList />
			<NotificationPrefs />
			<PushToggle />
		</div>
	);
}
